<template>
    <el-dialog :title="title" :visible.sync="visible" width="27%">
        <div class="yx-color-text-primary mb-20 fz-16">
            <img src="@/assets/public/warning-org.png" class="warn_img" alt="">
            <span>{{ content }}</span>
        </div>
        <span slot="footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { updApplyStatus } from '@/api/secondColonelManage';
export default {
    data() {
        return {
            visible: false,
            title: '手动设为未报名',
            content: ''
        }
    },
    methods: {
        show(params, title) {
            this.title = title
            this.params = params
            this.content = params.apply_status === '2' ? 
            '请确认该商品实际未报名该团长活动，确认后该商品将移动到“未报名”商品列表，不进行取消报名团长活动的操作'
            :'请确认该商品实际已经报名该团长活动，确认后该商品将移动到“已报名”商品列表，不进行重新报名团长活动的操作'
            this.visible = true
        },
        async confirm() {
            const { params } = this
            const { code } = await updApplyStatus(params)
            if(code !== 0) return
            this.$message.success('操作成功')
            this.$emit('refreshList')
            this.visible = false
        }
    }
}
</script>
<style lang='less' scoped>
.warn_img {
    width: 16px;
    height: 16px;
    margin-bottom: 2px;
    margin-right: 6px;
}
</style>